import React from "react"

export function Navbar(props){
    let classes = 'px-5 pt-5 ' + props.className
    return(
        <nav className={classes}>
            {props.children}
        </nav>
    )
}
